import * as Yup from 'yup';

// Enforces a "complete" email: local@domain.tld where the TLD is 2+ letters.
// - Plus-addressing (name+tag@domain.com) is preserved: '+' lives in the local part.
// - No TLD length cap, so .com/.co/.us and longer TLDs (.dental, .clinic, .health) all pass.
// - Catches the common mistake of a missing TLD, e.g. "name@example".
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

export const EMAIL_FORMAT_MESSAGE =
  'must be a complete email (e.g. name@example.com)';

// Builds a Yup string schema for an email field.
//   emailSchema()                   -> optional, format-checked only when a value is present
//   emailSchema({ required: true }) -> required + format-checked
//
// The base schema is nullable by default: Yup strings are non-nullable unless
// told otherwise, and the codebase's idiomatic initial value for optional
// strings is `record?.field || null`. Without nullable, a null initial value
// would fail with "this cannot be null" instead of being treated as blank.
// `required: true` still rejects null/empty (required wins over nullable), so
// required fields behave correctly.
export function emailSchema({
  required = false,
  nullable = true,
  requiredMessage = 'email is required',
} = {}) {
  let schema = Yup.string().trim().matches(EMAIL_REGEX, {
    message: EMAIL_FORMAT_MESSAGE,
    excludeEmptyString: true,
  });

  if (nullable) {
    schema = schema.nullable(true);
  }

  if (required) {
    schema = schema.required(requiredMessage);
  }

  return schema;
}
